export enum Role {
  Structure = 1,
  Training = 2,
  Profiles = 3,
  Employees = 4,
  Reports = 5,
  Uploads = 6,
  Messages = 7,
}
